const textColors = {
    'primary': 'text-white',
    'secondary': 'text-white',
    'success': 'text-white',
    'danger': 'text-white',
    'warning': 'text-dark',
    'info': 'text-white',
    'light': 'text-dark',
    'dark': 'text-white',
    'white': 'text-dark',
    'transparent': 'text-dark',
};

export function getTextClassFromType(type, defaultColor = 'text-dark') {
    return textColors.hasOwnProperty(type) ? textColors[type] : defaultColor;
}

export function getTextClassFromBgClass(bgClass) {
    return getTextClassFromType(bgClass.replace(/^bg\-/, ''));
}



